import { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";

import DashboardModal from "../student/components/DashboardModal";
import { CardDiv2, ProgressBar } from "../attendance/components/Master";
import { feesReportDashboard } from "../../api/FeesDeposite";
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    BarChart,
    Bar,
} from "recharts";
import { Bar as ChartJsBar } from "react-chartjs-2";
import TodayCollectionModal from "../TodayCollectionModal";

export default function FeesReportDashboard() {
    const [loading, setLoading] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [filters, setFilters] = useState({
        rte_type: "",
    });
    const [allFilters, setAllFilters] = useState({});


    const [data, setData] = useState({});

    useEffect(() => {
        const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
        setSessions(parseSessions);
    }, []);

    useEffect(() => {
        const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
        setFilters((prev) => {
            if (prev.session_id || !activeSession) return prev;
            return {
                ...prev,
                session_id: activeSession,
            };
        });
    }, [sessions]);

    const getFeesDashboard = async () => {
        setLoading(true);
        let addUrl = "";
        Object.keys(filters).forEach((key) => {
            const value = filters[key];
            if (value) {
                addUrl += `&${key}=${encodeURIComponent(value)}`;
            }
        });
        try {
            const response = await feesReportDashboard(addUrl);
            if (response.data.status) {
                setData(response?.data?.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.response?.message,
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFeesDashboard();
    }, [filters]);

    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">
                                <div className="row">
                                    <Master />
                                    <div className="col-12">
                                        <div className="row align-items-center g-2">


                                            <div className="card p-3  shadow-sm border-0">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div
                                                            style={{
                                                                width: 45,
                                                                height: 45,
                                                                borderRadius: "12px",
                                                                background:
                                                                    "linear-gradient(45deg,#185fa5,#4f8cff)",
                                                                color: "#fff",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <i className="ri-money-rupee-circle-line"></i>
                                                        </div>

                                                        <div>
                                                            <h5 className="m-0 fw-bold">
                                                                Fees Report / Dashboard
                                                            </h5>
                                                            <small className="text-muted">
                                                                Monitor fees collection and analytics
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className="d-flex align-items-center gap-2 justify-content-end">
                                                            <div className="form-floating form-floating-outline " style={{ minWidth: "220px" }}>
                                                                <select
                                                                    className="form-select"
                                                                    value={filters?.session_id}
                                                                    onChange={(e) =>
                                                                        setFilters({
                                                                            ...filters,
                                                                            session_id: e.target.value,
                                                                        })
                                                                    }
                                                                >
                                                                    {sessions?.map((s) => (
                                                                        <option key={s.id} value={s.id}>
                                                                            {s.session} :{" "}
                                                                            {s.status === "1" ? "Active" : "Inactive"}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <label>Session</label>
                                                            </div>
                                                            <div
                                                                className="form-floating form-floating-outline"
                                                                style={{ minWidth: "180px" }}
                                                            >
                                                                <select
                                                                    className="form-select"
                                                                    value={filters?.rte_type || ""}
                                                                    onChange={(e) =>
                                                                        setFilters({
                                                                            ...filters,
                                                                            rte_type: e.target.value,
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">All</option>
                                                                    <option value="RTE">RTE</option>
                                                                    <option value="NON-RTE">NON-RTE</option>
                                                                </select>
                                                                <label>RTE Type</label>
                                                            </div>


                                                        </div>



                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row g-3">

                                                <div className="col">
                                                    <div className="simple-card border-primary">
                                                        <small className="text-muted fw-bold">
                                                            Total Students
                                                        </small>
                                                        <h4 className="text-primary m-0">
                                                            {data?.summary?.total_students || 0}
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="simple-card border-success-emphasis">
                                                        <small className="text-muted fw-bold">
                                                            Total Fees
                                                        </small>
                                                        <h4 className="text-success-emphasis m-0">
                                                            ₹ {Number(data?.summary?.total_fee || 0).toLocaleString("en-IN")}
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="simple-card border-danger">
                                                        <small className="text-muted fw-bold">
                                                            Total Discount
                                                        </small>
                                                        <h4 className="text-danger m-0">
                                                            ₹ {Number(data?.summary?.total_discount || 0).toLocaleString("en-IN")}
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="simple-card border-info">
                                                        <small className="text-muted fw-bold">
                                                            Final Fee
                                                        </small>
                                                        <h4 className="text-info m-0">
                                                            ₹ {Number(data?.summary?.final_fee || 0).toLocaleString("en-IN")}
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="simple-card border-success">
                                                        <small className="text-muted fw-bold">
                                                            Collected Fees
                                                        </small>
                                                        <h4 className="text-success m-0">
                                                            ₹ {Number(data?.summary?.collected_fee || 0).toLocaleString("en-IN")}
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="simple-card border-warning">
                                                        <small className="text-muted fw-bold">
                                                            Pending Fees
                                                        </small>
                                                        <h4 className="text-warning m-0">
                                                            ₹ {Number(data?.summary?.pending_fee || 0).toLocaleString("en-IN")}
                                                        </h4>
                                                    </div>
                                                </div>

                                            </div>


                                            <div className="col-12">
                                                <div className="row g-4">
                                                    <div className="col-lg-7">
                                                        <div className="card border-0 rounded-3 h-100">
                                                            <div className="card-header bg-white border-0 py-2">
                                                                <h6 className="fw-bold mb-0">
                                                                    Monthly Fee Collection
                                                                </h6>
                                                            </div>

                                                            <div className="card-body">
                                                                <ResponsiveContainer width="100%" height={300}>
                                                                    <BarChart data={data?.monthly_collection || []}>
                                                                        <CartesianGrid strokeDasharray="3 3" />
                                                                        <XAxis dataKey="month" />
                                                                        <YAxis />
                                                                        <Tooltip
                                                                            cursor={false}
                                                                            formatter={(value) =>
                                                                                `₹ ${Number(value).toLocaleString("en-IN")}`
                                                                            }
                                                                        />
                                                                        <Bar
                                                                            dataKey="amount"
                                                                            fill="#6f71f0"
                                                                            radius={[6, 6, 0, 0]}
                                                                            barSize={30}
                                                                        />
                                                                    </BarChart>
                                                                </ResponsiveContainer>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-5">
                                                        <div className="card border-0 rounded-3">
                                                            <div className="card-header bg-white border-0 py-2">
                                                                <h6 className="fw-bold mb-0">Today's Activity</h6>
                                                            </div>

                                                            <div className="card-body">
                                                                <div className="row text-center g-3">

                                                                    {/* <div className="col">
                                                                        <div className="p-3 bg-success-subtle rounded-3 card-transform">
                                                                            <h4 className="fw-bold text-success mb-2">
                                                                                ₹ {Number(data?.today_activity?.collection || 0).toLocaleString("en-IN")}
                                                                            </h4>
                                                                            <p className="mb-0">Today's Collection</p>
                                                                        </div>
                                                                    </div> */}

                                                                    <div
                                                                        className="col"
                                                                        style={{ cursor: "pointer" }}
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#todayCollection"
                                                                    >
                                                                        <div className="p-3 bg-success-subtle rounded-3 card-transform">
                                                                            <h4 className="fw-bold text-success mb-2">
                                                                                ₹ {Number(data?.today_activity?.collection || 0).toLocaleString("en-IN")}
                                                                            </h4>
                                                                            <p className="mb-0">Today Collection</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col">
                                                                        <div className="p-3 bg-warning-subtle rounded-3 card-transform">
                                                                            <h4 className="fw-bold text-warning mb-2">
                                                                                {data?.today_activity?.due || 0}
                                                                            </h4>
                                                                            <p className="mb-0">Due Students</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col">
                                                                        <div className="p-3 bg-info-subtle rounded-3 card-transform">
                                                                            <h4 className="fw-bold text-info mb-2">
                                                                                {data?.today_activity?.transactions || 0}
                                                                            </h4>
                                                                            <p className="mb-0">Transactions</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>



                                                            {/* Old Fees Summary */}
                                                            {Number(data?.summary?.old_due_fees || 0) > 0 && (
                                                                <div className="card border-0 rounded-3">
                                                                    <div className="card-header bg-white border-0 py-2">
                                                                        <h6 className="fw-bold mb-0">Old Fees Summary</h6>
                                                                    </div>

                                                                    <div className="card-body">
                                                                        <div className="row g-3 text-center">

                                                                            <div className="col-4">
                                                                                <div className="p-3 bg-danger-subtle rounded-3">
                                                                                    <h5 className="fw-bold text-danger mb-1">
                                                                                        ₹ {Number(data?.summary?.old_due_fees || 0).toLocaleString("en-IN")}
                                                                                    </h5>
                                                                                    <small>Old Due</small>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-4">
                                                                                <div className="p-3 bg-success-subtle rounded-3">
                                                                                    <h5 className="fw-bold text-success mb-1">
                                                                                        ₹ {Number(data?.summary?.old_paid_fees || 0).toLocaleString("en-IN")}
                                                                                    </h5>
                                                                                    <small>Old Paid</small>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-4">
                                                                                <div className="p-3 bg-warning-subtle rounded-3">
                                                                                    <h5 className="fw-bold text-warning mb-1">
                                                                                        ₹ {Number(data?.summary?.old_pending_fees || 0).toLocaleString("en-IN")}
                                                                                    </h5>
                                                                                    <small>Pending</small>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )}


                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-header py-2">
                                                        <h5 className="fw-bold mb-0">
                                                            Batch Wise Fees Summary
                                                        </h5>
                                                    </div>

                                                    <div className="table-responsive">
                                                        <table className="table align-middle mb-0">
                                                            <thead className="table-active">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Batch</th>
                                                                    <th>Staff</th>
                                                                    <th>Total Students</th>
                                                                    <th>Final Fee</th>
                                                                    <th>Discount</th>
                                                                    <th>Collection</th>
                                                                    <th>Pending</th>
                                                                    <th>Status</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {data?.batch_summary?.map((batch, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td>
                                                                            <b>{batch.batch_name}</b>
                                                                        </td>

                                                                        <td>
                                                                            {batch.class_teacher_info || "-"}
                                                                        </td>

                                                                        <td className="text-primary fw-bold">
                                                                            {batch.total_students}
                                                                        </td>

                                                                        <td className="text-info fw-bold">
                                                                            ₹ {Number(batch.final_fee || 0).toLocaleString("en-IN")}
                                                                        </td>

                                                                        <td className="text-danger fw-bold">
                                                                            ₹ {Number(batch.discount || 0).toLocaleString("en-IN")}
                                                                        </td>

                                                                        <td className="text-success fw-bold">
                                                                            ₹ {Number(batch.collection || 0).toLocaleString("en-IN")}
                                                                        </td>

                                                                        <td>
                                                                            <span className="badge bg-warning">
                                                                                ₹ {Number(batch.pending || 0).toLocaleString("en-IN")}
                                                                            </span>
                                                                        </td>
                                                                        <td className="fw-bold">
                                                                            {batch.status == 0 && (
                                                                                <span className="badge bg-warning">Not Started</span>
                                                                            )}

                                                                            {batch.status == 1 && (
                                                                                <span className="badge bg-success">Started</span>
                                                                            )}

                                                                            {batch.status == 2 && (
                                                                                <span className="badge bg-info">Finished</span>
                                                                            )}

                                                                            {batch.status == 3 && (
                                                                                <span className="badge bg-danger">Deleted</span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DashboardModal
                setLoading={setLoading}
                allFilter={allFilters}
                setAllFilter={setAllFilters}
            />

            <TodayCollectionModal />
        </>
    );
}
